import React from "react";
import { Outlet } from "react-router-dom";
import { Container, TopBackground, BottomBackground } from "../styles";

export default function AuthLayout() {
  return (
    <Container>
      {/* <TopBackground /> */}
      {/* <BottomBackground /> */}
      <Outlet />
    </Container>
  );
}
